import { ContentHeader } from '@features/ui/components';
import { useTranslation } from 'next-i18next';

export const ContactsContentHeader = (): JSX.Element => {
  const { t } = useTranslation('common');

  return (
    <ContentHeader
      title={t('pages.contacts.contentHeader.title')}
      upperTitle={t('pages.contacts.contentHeader.upperTitle')}
    />
  );
};
